import React from "react";
// import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
// import Header from "components/Header/Header.jsx";
// import HeaderLinks from "components/Header/HeaderLinks.jsx";
// sections of this Page
import SectionHeaders from "./Sections/SectionHeaders.jsx";
import SectionFeatures from "./Sections/SectionFeatures.jsx";
// import SectionBlogs from "./Sections/SectionBlogs.jsx";
// import SectionTeams from "./Sections/SectionTeams.jsx";
import SectionProjects from "./Sections/SectionProjects.jsx";
import SectionWorkwith from "./Sections/SectionWorkwith.jsx";
import SectionPricing from "./Sections/SectionPricing.jsx";
import SectionWhatWeWill from "./Sections/SectionWhatWeWill.jsx";
import SectionContacts from "./Sections/SectionContacts.jsx";
import SectionFooter from "./Sections/SectionFooter.jsx";

import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.jsx";

class SectionsPage extends React.Component {
  // constructor(props) {
  //   // console.log("SectionsPage constructor");
  //   super(props);

  //   this.didUpdateView = true;
  //   // this.state = {
  //   //   didUpdateView: false
  //   // };
  // }
  componentDidMount() {
    // console.log("componentDidMount");
    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (window.location.href.lastIndexOf("#") > 0)
      document.getElementById(href).scrollIntoView();
    window.addEventListener("scroll", this.updateView);
    this.updateView();
  }
  componentDidUpdate() {
    // console.log("componentDidUpdate");
    // this.didUpdateView = true;
    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    document.getElementById(href).scrollIntoView();
  }
  componentWillUnmount() {
    // console.log("componentWillUnmount");
    window.removeEventListener("scroll", this.updateView);
  }
  easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }
  updateView() {
    // console.log("-- updateView:" + this.didUpdateView);
    // if(this.didUpdateView === undefined || this.didUpdateView === false) {
    //   this.didUpdateView = true;
    //   // console.log("++ updateView:" + this.didUpdateView);
    //   // this.setState({
    //   //   didUpdateView: true
    //   // });

    //   return;
    // }

    var contentSections = document.getElementsByClassName("cd-section");
    var navigationItems = document
      .getElementById("cd-vertical-nav")
      .getElementsByTagName("a");

    // console.log("will do updateView:" + contentSections.length);
    for (let i = 0; i < contentSections.length; i++) {
      // var activeSection =
      //   parseInt(navigationItems[i].getAttribute("data-number"), 10) - 1;
      var activeSection =
        parseInt(navigationItems[i].getAttribute("data-number"), 8) - 1;
        // console.log("updateView activeSection:" + activeSection);
        if (
        contentSections[i].offsetTop - window.innerHeight / 2 <
          window.pageYOffset &&
        contentSections[i].offsetTop +
          contentSections[i].scrollHeight -
          window.innerHeight / 2 >
          window.pageYOffset
      ) {
        // console.log("add selected activeSection:" + activeSection);
        navigationItems[activeSection].classList.add("is-selected");
        // this.didUpdateView = true;
      } else {
        // console.log("remove selected activeSection:" + activeSection);
        navigationItems[activeSection].classList.remove("is-selected");
      }
    }
    // this.didUpdateView = false;
  }
  smoothScroll(target) {
    var targetScroll = document.getElementById(target);
    this.scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
  }
  scrollGo(element, to, duration) {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = this.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    }.bind(this);
    animateScroll();
  }
  render() {
    // console.log("render");
    const { classes } = this.props;
    return (
      <div>
        {/* <Header
          color="info"
          brand="Material Kit PRO React"
          links={<HeaderLinks dropdownHoverColor="info" />}
          fixed
        /> */}
        <div className={classes.main}>
          <SectionHeaders id="home" />
          {/* <SectionBlogs id="blogs" /> */}
          {/* <SectionTeams id="teams" /> */}
          <SectionProjects id="products" />
          <SectionWorkwith id="workwith" />
          <SectionPricing id="pricing" />
          {/* <SectionTestimonials id="testimonials" /> */}
          <SectionFeatures id="aboutus" />
          <SectionWhatWeWill id="whatwewill" />
          <SectionContacts id="contacts" />
          <SectionFooter id="footer" />
        </div>
        <nav id="cd-vertical-nav">
          <ul>
            <li>
              <a
                href="#home"
                data-number="1"
                // className="is-selected"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("headers");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Home</span>
              </a>
            </li>
            {/* <li>
              <a
                href="#blogs"
                data-number="3"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("blogs");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Blogs</span>
              </a>
            </li> */}
            {/* <li>
              <a
                href="#teams"
                data-number="4"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("teams");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Teams</span>
              </a>
            </li> */}
            <li>
              <a
                href="#products"
                data-number="2"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("projects");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Products</span>
              </a>
            </li>
            <li>
              <a
                href="#workwith"
                data-number="3"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("workwith");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Work with</span>
              </a>
            </li>

            <li>
              <a
                href="#pricing"
                data-number="4"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("pricing");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">料金表</span>
              </a>
            </li>
            {/* <li>
              <a
                href="#testimonials"
                data-number="7"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("testimonials");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Testimonials</span>
              </a>
            </li> */}
            <li>
              <a
                href="#aboutus"
                data-number="5"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("features");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Who we are</span>
              </a>
            </li>
            <li>
              <a
                href="#whatwewill"
                data-number="6"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("whatwewill");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">What we will</span>
              </a>
            </li>
            <li>
              <a
                href="#contacts"
                data-number="7"
                className=""
                onClick={e => {
                  // var isMobile = navigator.userAgent.match(
                  //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
                  // );
                  var isMobile = true;
                  if (isMobile) {
                    // if we are on mobile device the scroll into view will be managed by the browser
                  } else {
                    e.preventDefault();
                    this.smoothScroll("contacts");
                  }
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">お問合せ</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

// SectionsPage.propTypes = {
//   classes: PropTypes.object.isRequired,
//   // index of the default active collapse
//   active: PropTypes.oneOfType([
//     PropTypes.number,
//     PropTypes.arrayOf(PropTypes.number)
//   ]),
//   collapses: PropTypes.arrayOf(
//     PropTypes.shape({
//       title: PropTypes.string,
//       content: PropTypes.node
//     })
//   ).isRequired,
//   activeColor: PropTypes.oneOf([
//     "primary",
//     "secondary",
//     "warning",
//     "danger",
//     "success",
//     "info",
//     "rose"
//   ])
// };

export default withStyles(sectionsPageStyle)(SectionsPage);



// WEBPACK FOOTER //
// ./src/views/SectionsPage/SectionsPage.jsx